// extracted by mini-css-extract-plugin
export var dropdownIcon = "_p3-6";
export var imgContainer = "_p3-3";
export var menuIcon = "_p3-5";
export var pillWrapper = "_p3-2";
export var pillsContainer = "_p3-1";
export var subscriptionCard = "_p3-0";
export var subscriptionLogo = "_p3-4";